// ============================================================================
// What a worker actually has to be told, in one place.
//
// ⛔ THE CODE ON ITS OWN IS USELESS (Ben, 2026-09-22): "How does Antonela send
// Link and Pin for workers? I see pin generation, but no link." The address a
// worker has to open appeared NOWHERE in this app — not on the code screen, not
// on their record, not on the phones list. She had the code and no way to say
// where to put it.
//
// ⛔ NOTHING HERE SENDS. There is no email or SMS provider connected and none
// is being added. This builds the words; the person copies them and sends them
// the way they already talk to that worker — which is why every button that
// uses this says "copy", never "send".
// ============================================================================

import type { WorkerLang } from './types';

/** The worker door's address, on whatever host this app is served from. */
export function clockUrl(): string {
  const origin = typeof window === 'undefined' ? 'https://app.terminalcleaning.com' : window.location.origin;
  return `${origin}/clock`;
}

/** The address without its scheme — what a person reads out over the phone. */
export function clockUrlSpoken(): string {
  return clockUrl().replace(/^https?:\/\//, '');
}

/**
 * The message to hand a worker: where to go, who they are, and their code.
 *
 * ⛔ In THEIR language, read off their record — the same preference the clock
 * page itself reads. Spanish for anybody with none recorded.
 * ⛔ The code appears in the text because this is the one moment it can be
 * passed on; it is stored only as a hash and can never be looked up again.
 */
export function joiningMessage(lang: WorkerLang, firstName: string, pin: string): string {
  const url = clockUrlSpoken();
  if (lang === 'en') {
    return [
      `Hi ${firstName} — this is how you clock in and out at Terminal Cleaning Services.`,
      '',
      `1. Open ${url} on your phone.`,
      '2. Put in your own mobile number and this PIN: ' + pin,
      '3. The page will tell you which building you are at. Tap PUNCH IN when you start and PUNCH OUT when you finish.',
      '',
      'Save that page to your home screen so it is one tap next time. Your PIN is yours — do not share it.',
    ].join('\n');
  }
  return [
    `Hola ${firstName} — así marcas tu entrada y tu salida en Terminal Cleaning Services.`,
    '',
    `1. Abre ${url} en tu teléfono.`,
    '2. Pon tu propio número de celular y este PIN: ' + pin,
    '3. La página te va a decir en qué edificio estás. Toca MARCAR ENTRADA cuando empieces y MARCAR SALIDA cuando termines.',
    '',
    'Guarda esa página en tu pantalla de inicio para que sea un solo toque la próxima vez. Tu PIN es tuyo — no lo compartas.',
  ].join('\n');
}
